export default {"src":"/_next/static/media/discount.7c3ede60.svg","height":2200,"width":2200,"blurWidth":0,"blurHeight":0};